import React from 'react';
import styles from './UserDropdown.module.scss';
import UserDropdownItem from './UserDropdownItem/UserDropdownItem';
import UserDropdownAccount from './UserDropdownAccount/UserDropdownAccount';
import Div from '../Element/Div/Div';
import Flex from '../Flex/Flex';
import Icon from '../Icon/Icon';
import Gutter from '../Gutter/Gutter';
import { CommonProps } from '../Element/Element';

type UserDropdownProps = {
  /** Element comes after icon */
  label?: React.ReactNode;
  /** Boolean that enables open dropdown */
  isOpen?: boolean;
  /** Boolean that enables responsive dropdown */
  mobileResponsive?: boolean;
} & CommonProps<'div'>;

const UserDropdown: React.FunctionComponent<UserDropdownProps> & {
  Item: typeof UserDropdownItem;
  Account: typeof UserDropdownAccount;
} = ({ label, isOpen, mobileResponsive, children, ...props }) => {
  return (
    <Div
      className={[
        [styles.userDropdown_container__relative],
        {
          [styles.userDropdown_container__mobileResponsive]: mobileResponsive,
        },
      ]}
      {...props}
    >
      <Flex centeredVertically>
        <Icon
          clickableAppearance
          responsiveHidden={{ widerThan: 'sm' }}
          margin={{ vertical: 'sm' }}
          name="end-user"
          size="md"
        />
      </Flex>

      <Flex
        responsiveHidden={{ thinnerThan: 'md' }}
        centeredVertically
        clickableAppearance
        margin={{ vertical: 'md' }}
      >
        <Icon name="end-user" size="md" />

        <Gutter size="sm" />

        {label}

        <Gutter />

        <Icon
          name={!isOpen ? 'chevron-down' : 'chevron-up'}
          size="sm"
          color="purple500"
          className="user-dropdown-arrow-icon-test"
        />
      </Flex>

      {isOpen && (
        <Div
          block
          backgroundColor="white"
          boxShadow="sm"
          className={[
            styles.userDropdown_items,
            {
              [styles.userDropdown_items__mobileResponsive]: mobileResponsive,
            },
            'dropdown-items-tests',
          ]}
        >
          {children}
        </Div>
      )}
    </Div>
  );
};

UserDropdown.Account = UserDropdownAccount;
UserDropdown.Item = UserDropdownItem;

export default UserDropdown;
